import pkg from "../package.json";

export const BASE_APP_NAME = pkg.name;
export const APP_VERSION = pkg.version;
export const ADE_URL = import.meta.env.VITE_APP_ADE_URL;
export const VITE_APP_ENV = import.meta.env.VITE_APP_ENV;
export const BFF_URL =
    import.meta.env.VITE_APP_GOVERNMENT_AGENCY_HUB_BFF_URL ||
    "http://localhost:3456";
